import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import AdditionalRecipients from "../../../../_utils/AccountCreationComponents/AdditionalRecipients";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import SingleOptionSelector from "../../../../_utils/AccountCreationComponents/SingleOptionSelector";
import CommonLayout from "../../../../_utils/CommonLayout";
import CommonAssignLabelPopup from "../../../../_utils/CommonPopups/CommonAssignLabelPopup";
import AdditionalRecipientCreate from "../../../../AdditionalRecipientCreate";

const TaxAccountStepTaxType = (props) => {
  const { id } = useParams();

  const openAdditionalRecipients = () => {
    const confirmed = props?.createRecipient || [];
    props?.setTempRecipients(confirmed);
    props?.setOriginalRecipients(confirmed);
    props?.setShowAdditionalSection(true);
  };

  const handleConfirmRecipients = () => {
    if (props?.recipientButtonDisabled) return;

    props?.setCreateRecipient(props?.tempRecipients);
    props?.setShowAdditionalSection(false);
  };

  const handleTaxSelect = (option) => {
    props?.setSelectedTaxType(option);

    const normalized = option.name.toLowerCase();

    props?.setPayload((prev) => ({
      ...prev,
      type_of_account: normalized,
      category: normalized,
      tax_type_label: option.name,
      sectionCode: normalized === "tds" ? "" : "",
      tax_section_id: normalized === "tds" ? prev.tax_section_id : undefined,
    }));
  };

  const handleSectionSelect = (option) => {
    if (option?.disabled) return;

    props?.setPayload((prev) => ({
      ...prev,
      sectionCode: option.name,
      tax_section_id: option.id,
    }));
  };

  useEffect(() => {
    const changed =
      JSON.stringify(props?.tempRecipients) !==
      JSON.stringify(props?.originalRecipients);

    props?.setRecipientButtonDisabled(!changed);
  }, [props?.tempRecipients, props?.originalRecipients]);

  useEffect(() => {
    const availableLabels = sessionStorage?.getItem("TaxAvailableLabels");
    if (availableLabels) {
      try {
        const parsedLabels = JSON.parse(availableLabels);
        props?.setLabels(parsedLabels || []);
      } catch (err) {
        console.error("Failed to parse AvailableLabels", err);
        props?.setLabels([]);
      }
    }
  }, []);

  useEffect(() => {
    if (props?.labelPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [props?.labelPopup]);

  const handleClose = () => {
    props?.setLabelPopup(false);
    props?.setPayload((prevPayload) => ({
      ...prevPayload,
      labels: props?.selectedLabelsCreate,
    }));
  };

  const filteredTaxOptions = props?.taxOptions;

  return (
    <>
      {props?.showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipientCreate
            type="createFlow"
            finalRecipients={props?.createRecipient}
            initialRecipientCount={GlobalConfiguration.lengthCheckZero}
            setShowAdditionalSection={props?.setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={props?.showAdditionalRecipient}
            setShowAdditionalRecipient={props?.setShowAdditionalRecipient}
            handleConfirm={handleConfirmRecipients}
            recipients={props?.tempRecipients}
            setRecipients={props?.setTempRecipients}
            buttonDisabled={props?.recipientButtonDisabled}
            setButtonDisabled={props?.setRecipientButtonDisabled}
            additionalChip={props?.additionalChip}
            setAdditionalChip={props?.setAdditionalChip}
          />
        </div>
      )}

      {props?.labelPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext={
              "Labels will be used to generate statistics for the associated accounts."
            }
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={props?.labels}
            setLabels={props?.setLabels}
            isLabelPopupOpen={props?.labelPopup}
            selectedLabelsCreate={props?.selectedLabelsCreate}
            setSelectedLabelsCreate={props?.setSelectedLabelsCreate}
            loading={props?.labelPopupLoading}
            setLoading={props?.setLabelPopupLoading}
            type="create"
          />
        </div>
      )}
      <div className="px-padding-md w-width-full Qlg:px-padding-base py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <SingleOptionSelector
            title="Tax Type"
            subTitle="Select a tax type in order to continue with the account creation. This account will be used to process selected type of transaction."
            options={filteredTaxOptions}
            selectedOption={props?.selectedTaxType}
            metaMap={props?.taxMeta}
            onSelect={handleTaxSelect}
            iconResolver={props?.resolveTaxIcon}
            getLabel={(item) => props?.formatTaxLabel(item?.name)}
            getKey={(item) => item?.name?.toLowerCase()}
          />

          {props?.selectedTaxType?.name?.toLowerCase() === "tds" && (
            <SingleOptionSelector
              title="Tax Section"
              subTitle="Select the applicable section for your tax account."
              options={props?.sectionOptions}
              selectedOption={
                props?.sectionOptions?.find(
                  (opt) => opt.id === props?.payload?.tax_section_id,
                ) || null
              }
              metaMap={props?.sectionMeta}
              onSelect={handleSectionSelect}
              showIcon={false}
              isSectionType={true}
            />
          )}

          <AssignLabels
            setLabelpopup={props?.setLabelPopup}
            labels={props?.payload?.labels}
            subText1="Labels will be used to generate statistics for the associated
                accounts."
            isOptional={true}
          />

          <div className="w-width-full lg:max-w-[var(--create-box-width)] min-w-min-width-base pb-padding-md Qsmd:pb-padding-base">
            <AdditionalRecipients
              setShowAdditionalSection={openAdditionalRecipients}
              recipients={props?.createRecipient}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default TaxAccountStepTaxType;
